import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Radio, Stack, Typography, useTheme } from '@mui/material';
import type { ReactNode } from 'react';

import { CardSelectable } from '@woovi/ui';

type PaymentMethodSelectableCardProps = {
  onClick: (value: string) => void;
  isSelected: boolean;
  value: string;
  label: string;
  icon: ReactNode;
  disabled?: boolean;
};

const PaymentMethodSelectableCard = ({
  value,
  label,
  icon,
  isSelected,
  onClick,
  disabled = false,
}: PaymentMethodSelectableCardProps): ReactNode => {
  const theme = useTheme();

  const handleClick = (): void => {
    if (disabled) {
      return;
    }

    onClick(value);
  };

  return (
    <CardSelectable
      isSelected={isSelected}
      onClick={handleClick}
      sx={{ p: 1, pl: 2 }}
      disabled={disabled}
    >
      <Stack
        direction='row'
        sx={{ justifyContent: 'space-between', alignItems: 'center' }}
      >
        <Stack
          direction='row'
          sx={{
            gap: 1,
          }}
        >
          {icon}
          <Typography>{label}</Typography>
        </Stack>
        <Radio
          checked={isSelected}
          checkedIcon={
            <CheckCircleIcon
              sx={{
                color: disabled
                  ? theme.palette.text.disabled
                  : theme.palette.primary.main,
              }}
            />
          }
        />
      </Stack>
    </CardSelectable>
  );
};

export default PaymentMethodSelectableCard;
